//Components
import Header from '../../components/pageHeader.js'

//Styling
import './staff.scss'
import '../../dashboard.scss'

//Functions and Data
import config from './config.js'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import React, { useEffect, useState } from 'react'
import { fetchAll } from '../../../../modules/users.js'
import { sendRequest } from '../../../../modules/admin.js'
import { fetchClass } from '../../../../modules/bookings.js'

import baseconfig from '../../../../variables/config.js'
import axios from 'axios'
import { createDefaultObj, nullCoalesce } from './misc.js'

const StaffManager = ({ isOpen, sendRequest, bookings, users }) => {
  const isSouthampton = baseconfig.branch === 'Southampton'
  const branchNames = isSouthampton
    ? ['Southampton']
    : ['Redhill', 'Kingston']

  const [tab, setTab] = useState(0)
  const [tabs] = useState(
    branchNames.map((name, index) => ({
      name,
      cb: () => {
        setTab(index)
        resetSelected()
      }
    }))
  )

  const [staffList, setStaffList] = useState([])
  const [selected, setSelected] = useState(-1) //selected index
  const [isEditing, setEditing] = useState(true)
  const [isLoading, setLoading] = useState(false)
  const [isAdding, setAdding] = useState(false) //in the process of adding a new staff obj

  const [unauthorised, setUnauthorised] = useState(false)

  const [token] = useState(
    JSON.parse(window.localStorage.getItem('userData')).token
  )

  useEffect(() => {
    fetchStaff()
    sendRequest(fetchAll)
  }, [])

  useEffect(() => {
    console.log('Staff List Updated:', staffList)
  }, [staffList])

  useEffect(() => {
    if (users.length > 0) {
      sendRequest(fetchClass)
    }
  }, [users])

  const fetchStaff = async cb => {
    setLoading(true)
    try {
      const response = await axios.get(_url('StaffUsers'))
      const list = [...response.data]
      list.forEach(staff => {
        staff.branch = staff.realm
      })
      setStaffList(list)
    } catch (error) {
      if (error.response && error.response.status === 401) {
        setUnauthorised(true)
      }

      console.error('Error fetching staff:', { error })
    } finally {
      setLoading(false)
      if (cb) cb()
      if (isAdding) {
        setAdding(false)
        resetSelected()
      }
    }
  }

  const _url = (modelType, id = null) => {
    let model = modelType
    let str = baseconfig.serverURL + '/' + model
    if (id) str += '/' + id
    return str + '?access_token=' + token
  }

  const createStaff = async staffData => {
    setLoading(true)

    const [isValid, validationMsg] = validateStaffData(staffData, true)
    if (!isValid) {
      alert('Error creating staff: ' + validationMsg)
      setLoading(false)
      return
    }

    delete staffData.branch //remove branch field. It's only there for frontend use
    delete staffData.confirm //remove confirm field. It's only there for frontend use

    try {
      const response = await axios.post(_url('StaffUsers'), staffData)
      console.log('Staff created:', response.data)
      fetchStaff()
      resetSelected()
    } catch (error) {
      console.error('Error creating staff:', error)
    } finally {
      setLoading(false)
    }
  }

  const updateStaff = async staffData => {
    setLoading(true)

    const [isValid, validationMsg] = validateStaffData(staffData, false)
    if (!isValid) {
      alert('Error updating staff: ' + validationMsg)
      setLoading(false)
      return
    }

    const { id } = staffData

    delete staffData.branch //remove branch field. It's only there for frontend use
    delete staffData.id

    if (!staffData.password) delete staffData.password //don't send password field if it's empty

    try {
      const response = await axios.patch(_url('StaffUsers', id), staffData)
      console.log('Staff updated:', response.data)
      fetchStaff()
      resetSelected()
    } catch (error) {
      console.error('Error updating staff:', error)
    } finally {
      setLoading(false)
    }
  }

  const deleteStaff = async staffId => {
    setLoading(true)
    try {
      const response = await axios.delete(_url('StaffUsers', staffId))
      console.log('Staff deleted:', response.data)
      fetchStaff()
      resetSelected()
    } catch (error) {
      console.error('Error deleting staff:', error)
    } finally {
      setLoading(false)
    }
  }

  const validateStaffData = (staffData, isCreating) => {
    //Add validation logic as needed
    const { firstName, lastName, email, password, confirm } = staffData
    if (!firstName || !lastName || !email)
      return [false, 'All fields are required.']

    if (!/\S+@\S+\.\S+/.test(email)) {
      return [false, 'Invalid email format.']
    }

    if (isCreating || password) {
      //Additional checks for creating new staff
      if (!password) return [false, 'Password is required for new staff.']
      if (password.length < 6) {
        return [false, 'Password must be at least 6 characters long.']
      }
      if (!/[A-Z]/.test(password)) {
        return [false, 'Password must contain at least one uppercase letter.']
      }
      if (!/[a-z]/.test(password)) {
        return [false, 'Password must contain at least one lowercase letter.']
      }
      if (!/[0-9]/.test(password)) {
        return [false, 'Password must contain at least one number.']
      }
      if (!/[\W_]/.test(password)) {
        return [false, 'Password must contain at least one special character.']
      }
      if (password !== confirm) {
        return [false, 'Passwords do not match.']
      }
    }

    return [true]
  }

  const handleEditClick = () => {
    if (isEditing) {
      //Clicked Cancel Changes
      setEditing(false)
      fetchStaff()
    } else {
      //Clicked Edit Changes
      setEditing(true)
    }
  }

  const resetSelected = () => {
    setSelected(-1)
    setEditing(false)
  }

  const updateSelected = index => {
    if (index === selected) {
      setSelected(-1)
    } else {
      setSelected(index)
    }
    if (index === 0 && isAdding) {
      setEditing(true)
      return
    }
    setEditing(false)
  }

  const handleInputChange = (e, id, field) => {
    const value = e.target.value
    console.log('handleInputChange:', field, '=', value)

    setStaffList(prevList => {
      const newList = [...prevList]
      const index = newList.findIndex(staff => staff.id === id) //find by unique id
      console.log('handleInputChange: before change', { staff: newList[index] })

      newList[index] = { ...newList[index], [field]: value }

      console.log('handleInputChange: after change', { staff: newList[index] })
      return newList
    })
  }

  const addNewStaffObj = () => {
    const branch = branchNames[tab]
    if (staffList[0] && !staffList[0].id) {
      alert('Please save the current new staff before adding another.')
      return
    }
    setStaffList([{ ...createDefaultObj(branch) }, ...staffList])
    setSelected(0)
    setEditing(true)
    setAdding(true)
  }

  /*
    TODO: Render Staff List. Styling, adding, editing, deleting.
    Remember to start on the logging system for actions taken.
    TODO: Add password confirmation components
  */
  const renderStaffList = () => {
    return staffList
      .filter(staff => staff.branch === branchNames[tab])
      .map((staff, index) => {
        return (
          <div key={index} className="listItem">
            <div className="itemRow dateObjHeader">
              {(selected !== index || !isEditing) && (
                <div className="staffName">
                  {'Name: ' + staff.firstName + ' ' + staff.lastName}
                </div>
              )}
              {isEditing && selected === index && (
                <div className="dateObjEditDates">
                  <div className="noBreak">{'First Name: '}</div>
                  <input
                    name={'firstName:' + index}
                    className="inputDateObj"
                    type="text"
                    value={staff.firstName}
                    onChange={e => handleInputChange(e, staff.id, 'firstName')}
                  />
                  <div className="noBreak">{'Last name: '}</div>
                  <input
                    name={'lastName:' + index}
                    className="inputDateObj"
                    type="text"
                    value={staff.lastName}
                    onChange={e => handleInputChange(e, staff.id, 'lastName')}
                  />
                </div>
              )}
              {!staff.id && (
                <div className="dateObjNew"> {'Unsaved New Staff'} </div>
              )}
              <div
                className="buttonWrapper"
                onClick={() => updateSelected(index)}
                disabled={isLoading}>
                {selected === index ? 'Hide Details' : 'Show Details'}
              </div>
            </div>
            {selected === index && (
              <>
                <div className="itemRow dateObjHeader">
                  {!isEditing ? (
                    <div>{'Branch: ' + staff.realm}</div>
                  ) : (
                    <>
                      <div className="noBreak rightPadding">{'Branch: '}</div>
                      <select
                        name={'realm:' + index}
                        className="inputDateObj"
                        value={staff.realm}
                        onChange={e => handleInputChange(e, staff.id, 'realm')}>
                        {branchNames.map(name => (
                          <option key={name} value={name}>
                            {name}
                          </option>
                        ))}
                      </select>
                    </>
                  )}
                </div>
                <div className="itemRow dateObjHeader">
                  {!isEditing ? (
                    <div>{'Email: ' + staff.email}</div>
                  ) : (
                    <>
                      <div className="noBreak rightPadding">{'Email: '}</div>
                      <input
                        name={'email:' + index}
                        className="inputDateObj"
                        type="text"
                        value={staff.email}
                        onChange={e => handleInputChange(e, staff.id, 'email')}
                      />
                    </>
                  )}
                </div>
                {isEditing && (
                  <>
                    <div className="itemRow dateObjHeader">
                      <div className="noBreak rightPadding">
                        {staff.id ? 'New Password: ' : 'Password: '}
                      </div>
                      <input
                        name={'password:' + index}
                        className="inputDateObj"
                        type="password"
                        placeholder={
                          staff.id ? 'leave blank to keep current' : undefined
                        }
                        value={nullCoalesce(staff.password, '')}
                        onChange={e =>
                          handleInputChange(e, staff.id, 'password')
                        }
                      />
                    </div>
                    <div className="itemRow passwordNote">
                      {
                        'Password must be at least 6 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.'
                      }
                    </div>
                    <div className="itemRow dateObjHeader">
                      <div className="noBreak rightPadding">
                        {staff.id
                          ? 'Confirm New Password: '
                          : 'Confirm Password: '}
                      </div>
                      <input
                        name={'password:' + index}
                        className="inputDateObj"
                        type="password"
                        placeholder={
                          staff.id ? 'leave blank to keep current' : undefined
                        }
                        value={nullCoalesce(staff.confirm, '')}
                        onChange={e =>
                          handleInputChange(e, staff.id, 'confirm')
                        }
                      />
                    </div>
                  </>
                )}

                <div className="itemRow">
                  <div
                    className="buttonWrapper"
                    onClick={() => handleEditClick()}
                    disabled={isLoading}>
                    {isEditing ? 'Cancel Changes' : 'Edit Details'}
                  </div>
                  {isEditing ? (
                    <div
                      className="buttonWrapper"
                      onClick={() =>
                        staff.id ? updateStaff(staff) : createStaff(staff)
                      }
                      disabled={isLoading}>
                      {staff.id ? 'Save Changes' : 'Add New Staff'}
                    </div>
                  ) : (
                    <div
                      className="buttonWrapper"
                      onClick={() => {
                        if (
                          window.confirm(
                            'Are you sure you want to delete this staff?'
                          )
                        ) {
                          deleteStaff(staff.id)
                        }
                      }}
                      disabled={isLoading}>
                      {'Delete Staff'}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        )
      })
  }

  return (
    <div className={'component' + (isOpen ? '' : ' componentClosed')}>
      {!unauthorised && (
        <>
          <Header
            title={config.mainTitle}
            tip={config.subHeading}
            icon={config.titleIcon}
            tabs={tabs}
            selected={tab}
          />
          <div className="scrollView">
            {!isAdding && !isLoading && (
              <div className="listItem" onClick={() => addNewStaffObj()}>
                <div className="buttonWrapper">{'Add New Staff'}</div>
              </div>
            )}
            {!isLoading && renderStaffList()}
            {isLoading && <div className="loadingText">Loading Staff...</div>}
          </div>
        </>
      )}
      {unauthorised && (
        <div className="unauthorisedMessage">
          You are not authorised to view this content. Only administrators can
          access staff management.
        </div>
      )}
    </div>
  )
}

const mapStateToProps = ({ bookings, users }) => ({
  users: users.users,
  bookings: bookings.classBookings
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StaffManager)
